import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[appOcultaElementosPaginador]' })
export class OcultaPaginadorPaginadorDirective implements AfterViewInit {

    @Input() ocultarLabelPagina: boolean = false;
    @Input() ocultarInputPagina: boolean = false;

    constructor(private el: ElementRef) { }

    ngAfterViewInit(): void {
        // Esperamos a que se renderice el contenido del paginador
        setTimeout(() => {
            const paginator = this.el.nativeElement as HTMLElement;

            if (this.ocultarLabelPagina) {
                const label = paginator.querySelector('.mat-mdc-paginator-page-size-label');
                if (label) label["style"].display = 'none';
            }

            if (this.ocultarInputPagina) {
                const input = paginator.querySelector('.mat-mdc-paginator-page-size-select');
                if (input) input["style"].display = 'none';
            }
        });
    }
}
